import React from "react"
import { Container, Block, TrustBox, ReviewsBirdeye } from "@components"

const siteLanguage = process.env.GATSBY_LANGUAGE

const PreFooter = ({ isJacuzzi = false }) => {
  const isNZ = siteLanguage === "en-NZ"

  const heading = "What our customers say about us"

  const lead = "We work hard for your Five Star ratings."

  return (
    <Container>
      <Block
        gutters
        padding={"double-top"}
        heading={heading}
        lead={lead}
        darkText={isJacuzzi}
      >
        <ReviewsBirdeye />
      </Block>
    </Container>
  )
}

export default PreFooter
